module.exports = __webpack_public_path__ + "logo-symbol.2be69f808de5f25592d5.png";


//////////////////
// WEBPACK FOOTER
// /Users/elliot/code/abc-angular/src/img/logo-symbol.png
// module id = ../../../../../src/img/logo-symbol.png
// module chunks = styles